import styled from "styled-components";
import { darken, rgba } from "polished";
import { MdOutlineMailOutline } from "react-icons/md";
import { SiLinkedin } from "react-icons/si";
import { BsDiscord, BsGithub } from "react-icons/bs";
import { IoMdDownload } from "react-icons/io";

export const List = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const CTAContainer = styled.li`
    display: flex;
    gap: 15px;

    @media screen and (max-width: 600px) {
        margin: 0 auto;
    }
`

export const ListContainer = styled.li`
    @media screen and (max-width: 600px) {
        margin: 0 auto;
    }
`;

const CTAButton = styled.button`
    padding: 1rem 2rem;
    font-size: 1.5rem;
    border-radius: 40px;
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    cursor: pointer;
    transition: all 200ms;
    white-space: nowrap;
    
    &:hover {
        box-shadow: 0px 0px 3px 4px ${({ theme }) => rgba(theme.colors.cta, .2)};
        filter: brightness(1.1);
    }
    
    &:active {
        filter: brightness(.98);
    }

    @media screen and (max-width: 1100px) {
        font-size: 1.2rem;
    }

    @media screen and (max-width: 600px) {
        font-size: 1rem;
        padding: 16px;
    }
`

export const ContactMeButton = styled(CTAButton)`
    border: none;
    background-color: ${({ theme }) => theme.colors.cta};
`;

export const DownloadIcon = styled(IoMdDownload)`
    fill: ${props => darken(.5, props.theme.colors.primary)};
    size: 1.3rem;
`

export const DownloadCVButton = styled(CTAButton)`
    background-color: ${props => props.theme.colors.whiteBg};
    border: 2px solid ${props => darken(.5, props.theme.colors.primary)};

    & > a {
        display: flex;
        align-items: center;

        gap: 5px;
        & > p {
            color: ${props => darken(.5, props.theme.colors.primary)};
        }
    }


    &:hover {
        color: white;
        background-color: ${props => darken(.5, props.theme.colors.primary)};

        & > a {
            & > ${DownloadIcon} {
                fill: ${props => props.theme.colors.whiteBg};
            }
    
            & > p {
                color: ${props => props.theme.colors.whiteBg};
            }
        }
    }
`;



export const GhButton = styled(BsGithub)`
    background-color: #0d1117;
    fill: white;
    padding: 5px;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;

    transition: all 150ms;

    &:hover {
        box-shadow: 0px 0px 3px 4px ${({ theme }) => rgba(theme.colors.cta, .2)};
    }

    @media screen and (max-width: 600px) {
        size: 1rem;
    }
`;

export const LinkedinButton = styled(SiLinkedin)`
    background-color: #0077B5;
    fill: white;
    padding: 5px;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;

    transition: all 150ms;

    &:hover {
        box-shadow: 0px 0px 3px 4px ${({ theme }) => rgba(theme.colors.cta, .2)};
    }

    @media screen and (max-width: 600px) {
        size: 1rem;
    }
`;

export const DiscordButton = styled(BsDiscord)`
    background-color: #7289DA;
    fill: white;
    padding: 5px;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;

    transition: all 150ms;

    &:hover {
        box-shadow: 0px 0px 3px 4px ${({ theme }) => rgba(theme.colors.cta, .2)};
    }

    @media screen and (max-width: 600px) {
        size: 1rem;
    }
`;

export const EmailButton = styled(MdOutlineMailOutline)`
    fill: white;
    background-color: #D93025;
    padding: 5px;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;

    transition: all 150ms;

    &:hover {
        box-shadow: 0px 0px 3px 4px ${({ theme }) => rgba(theme.colors.cta, .2)};
    }

    @media screen and (max-width: 600px) {
        size: 1rem;
    }
`;